const mutations = {
    smsUidMutation(state, value) {
        state.smsUid = value;
    },
};

export default mutations;